import script from "./ActivityCoupon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityCoupon.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityCoupon.vue?vue&type=style&index=0&id=631ed2e0&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631ed2e0"]])

export default __exports__